import * as React from "react";
import {AddFieldItem} from "./AddFieldItem";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";

export class AddField extends React.Component<AddFieldProps, AddFieldState> {
    static defaultProps: Partial<AddFieldProps> = {};

    constructor(props: AddFieldProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div>
                <AddFieldItem Image={'text.png'} Id={'TextInput'} Label={'Text Input'} DocumentManager={this.props.DocumentManager}/>
                <AddFieldItem Image={'checkbox.png'} Id={'CheckBox'} Label={'Checkbox'} DocumentManager={this.props.DocumentManager}/>
                <AddFieldItem Image={'dropdown.png'} Id={'DropDown'} Label={'Dropdown'} DocumentManager={this.props.DocumentManager}/>
                <AddFieldItem Image={'radio.png'} Id={'Radio'} Label={'Radio'} DocumentManager={this.props.DocumentManager}/>
                <AddFieldItem Image={'signature.png'} Id={'Signature'} Label={'Image/Signature'} DocumentManager={this.props.DocumentManager}/>
            </div>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AddFieldProps {
    DocumentManager:DocumentManager;
}

interface AddFieldState {

}

//#endregion "My Region"